// ─────────────────────────────────────────────────────────────────────────────
// OKR Plans (coach) — REST surface, quoted from BE_HANDOFF.md §2.7–2.9. All
// routes take the coach token.
// ─────────────────────────────────────────────────────────────────────────────

const BASE = "/coach/okr-plans";
const PLAN = (planId) => `${BASE}/plans/${planId}`;

export const OKR_PLANS_COACH_URLS = {
  COMPANIES: `${BASE}/companies`,
  QUARTERS: (companyId) => `${BASE}/companies/${companyId}/quarters`,
  MEMBERS: (companyId, quarterCompanyId) =>
    `${BASE}/companies/${companyId}/members?quarterCompanyId=${encodeURIComponent(quarterCompanyId)}`,
  PLAN,
  CHANGE_LOG: (planId, before) =>
    `${PLAN(planId)}/change-log${before ? `?before=${encodeURIComponent(before)}` : ""}`,
  REPORT: (planId, reportId) => `${PLAN(planId)}/reports/${reportId}`,
  CHAT_MESSAGES: (planId, chatId) => `${PLAN(planId)}/chats/${chatId}/messages`,
  CHECK_IN: (reportId) => `${BASE}/reports/${reportId}/check-in`,
  FINAL_REVIEW: (planId) => `${PLAN(planId)}/final-review`,
  FINAL_REVIEW_START: (planId) => `${PLAN(planId)}/final-review/start`,
  FINALISE: (planId) => `${PLAN(planId)}/final-review/finalise`,
  REMIND: (planId) => `${PLAN(planId)}/remind`,
  DOWNLOAD_FILE: (fileId) => `/shared/download/coach/${fileId}`,
};
